export { default } from './RegistrationWall';
